import { PRODUCT_TOUR_ACTIVE_KEY } from '~/utils/experiment/productTour';

// Shared "the product tour is running" flag; upsell openers read it to stay quiet during the tour.
export const useProductTourActive = () => useState<boolean>(PRODUCT_TOUR_ACTIVE_KEY, () => false);
